import { QueryClient } from '@tanstack/react-query'

export const invalidateAllRequisiteData = (queryClient: QueryClient, requisitId?: string) => {
  queryClient.invalidateQueries({ queryKey: ['requisites'] })
  queryClient.invalidateQueries({ queryKey: ['requisite-daily-stat'] })
  queryClient.invalidateQueries({ queryKey: ['requisite-total-stat'] })
  if (requisitId) {
    queryClient.invalidateQueries({ queryKey: ['requisit', requisitId] })
  }
}
